jQuery(document).ready(function($){
	console.log('test');
	if($('.sct-contact-form').length) {
		setTimeout(function(){
			disableContactFormButtonIfNoConsent();
		}, 500);

		$('.sct-contact-form').on('change', '.co-field-wrapper.consent-checkbox-wrapper input[type="checkbox"]', function(){
			disableContactFormButtonIfNoConsent();
		});
	}

	function disableContactFormButtonIfNoConsent() {
		if($('.sct-contact-form:has(.consent-checkbox-wrapper)').length) {
			$('.sct-contact-form:has(.consent-checkbox-wrapper)').each(function(){
				const checkboxes = $(this).find('.consent-checkbox-wrapper input[type="checkbox"]');
				const submitButton = $(this).find('button[type="submit"]');

				let consentGiven = true;
				checkboxes.each(function(){
					if(!this.checked) consentGiven = false;
				});

				submitButton.each(function(){
					$(this).attr('disabled', !consentGiven).prop('disabled', !consentGiven);
				});
			});
		}
	}
});